var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.message.type === "template" &&
    _vm.message.template.type === "carousel"
    ? _c(
        "div",
        [
          _c("div", { staticClass: "clearfix" }),
          _vm._v(" "),
          _c(
            "section",
            { staticClass: "mt-2 mb-3" },
            [
              _vm.message.template.data_type === "professional" ||
              _vm.message.template.data_type === "order"
                ? _c("div", { staticClass: "p-2" }, [
                    _vm.message.template.data_type === "professional"
                      ? _c("h3", { staticClass: "mb-0" }, [
                          _vm._v("เลือกผู้ให้บริการ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.message.template.data_type === "order"
                      ? _c("div", { staticClass: "d-flex" }, [
                          _c("div", { staticClass: "flex-fill" }, [
                            _c("h3", { staticClass: "mb-0" }, [
                              _vm._v(
                                "\n            การจองของคุณ\n            "
                              ),
                              _vm.message.template.order_status === "upcoming"
                                ? _c("span", [_vm._v("(ที่กำลังมา)")])
                                : _c("span", [_vm._v("(ที่เสร็จสิ้น)")])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex-fill text-right" }, [
                            _vm.message.template.order_status === "upcoming"
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "text-primary-link",
                                    attrs: { href: "" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.viewOrders(
                                          "my-reservations-history",
                                          _vm.txtPast
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.txtPast) +
                                        " "
                                    ),
                                    _c("i", { staticClass: "fas fa-history" })
                                  ]
                                )
                              : _c(
                                  "a",
                                  {
                                    staticClass: "text-primary-link",
                                    attrs: { href: "" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.viewOrders(
                                          "my-reservations",
                                          _vm.txtUpcoming
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.txtUpcoming) +
                                        "\n          "
                                    )
                                  ]
                                )
                          ])
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "carousel",
                {
                  attrs: {
                    perPage: _vm.perPage,
                    autoplay: false,
                    centerMode: false,
                    autoplayHoverPause: false,
                    navigationEnabled: false,
                    paginationEnabled: false,
                    loop: false,
                    scrollPerPage: false,
                    mouseDrag: true,
                    touchDrag: true
                  }
                },
                [
                  _vm.message.template.data_type === "professional"
                    ? _vm._l(_vm.message.template.columns, function(
                        column,
                        index
                      ) {
                        return _c("slide", { key: index }, [
                          _c("div", { staticClass: "card m-2" }, [
                            _c(
                              "div",
                              { staticClass: "card-body text-center" },
                              [
                                column.thumbnailImageUrl
                                  ? _c("img", {
                                      staticClass: "rounded-circle",
                                      attrs: {
                                        src: column.thumbnailImageUrl,
                                        alt: "",
                                        width: "60"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "mt-2" }, [
                                  _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("firstName")(column.title)
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("multiLangName")(
                                          _vm.globalState.cities[
                                            Number(column.data.province_id)
                                          ]
                                        )
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                column.data && !column.data.id
                                  ? _c("div", [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-size": "12px" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "message.my_reservations.in_case_urgent"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("hr")
                                    ])
                                  : _c("div", { staticClass: "py-2" }, [
                                      column.data.rating_qty
                                        ? _c("div", [
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$options.filters.ratingStar(
                                                    column.data.rating
                                                  )
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("div", [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "text-primary-link",
                                                  attrs: { href: "" },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.openProfessionalReviewsModal(
                                                        column.data
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        column.data.rating_qty
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$tc(
                                                          "message.professional.review",
                                                          column.data.rating_qty
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("hr", { staticClass: "my-2" })
                                    ]),
                                _vm._v(" "),
                                _vm._l(column.actions, function(action, index) {
                                  return _c("div", { key: index }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-outline-info btn-block",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.sendMessage(
                                              action,
                                              column.title
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(action.text) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ])
                                })
                              ],
                              2
                            )
                          ])
                        ])
                      })
                    : _vm.message.template.data_type === "order"
                    ? _vm._l(_vm.message.template.datas, function(
                        order,
                        index
                      ) {
                        return _vm.message.template.datas.length > 0
                          ? _c("slide", { key: index }, [
                              _c(
                                "div",
                                {
                                  staticClass: "card m-2",
                                  class:
                                    order.declined_order_data &&
                                    order.status === 0 &&
                                    order.selected_professional_id > 0
                                      ? "border border-danger"
                                      : ""
                                },
                                [
                                  _c("div", { staticClass: "card-body" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-content-start align-items-center mb-2"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "flex-fill" },
                                          [
                                            _vm._v(
                                              "\n                  #" +
                                                _vm._s(order.order_code) +
                                                " - "
                                            ),
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$options.filters.serviceParentName(
                                                    order.service_id,
                                                    _vm.globalState.services
                                                  )
                                                )
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", [
                                          _c("span", {
                                            staticClass: "text-remark",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$options.filters.orderStatus(
                                                  order
                                                )
                                              )
                                            }
                                          })
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-content-start align-items-top"
                                      },
                                      [
                                        _c("div", [
                                          _c("img", {
                                            staticClass: "rounded-circle",
                                            class:
                                              order.declined_order_data &&
                                              order.status === 0 &&
                                              order.selected_professional_id > 0
                                                ? "border border-danger"
                                                : "",
                                            attrs: {
                                              src: _vm.getProfessionalImage(
                                                order
                                              ),
                                              width: "48"
                                            }
                                          })
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "flex-fill pl-2" },
                                          [
                                            order.user_place
                                              ? _c("div", [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        order.user_place
                                                          .place_name
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("div", [
                                              order.cleaning_date
                                                ? _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("prettyDate")(
                                                          order.cleaning_date
                                                        )
                                                      )
                                                    )
                                                  ])
                                                : _c("b", [
                                                    _vm._v(
                                                      "ยังไม่ระบุวันที่รับบริการ"
                                                    )
                                                  ])
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              order.service_id === 1
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          order.work_hour
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.$tc(
                                                            "message.hour",
                                                            order.work_hour
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              order.order_service_items &&
                                              order.order_service_items.length
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.service_item.qty"
                                                          )
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.getCountServiceItems(
                                                            order.order_service_items
                                                          )
                                                        ) +
                                                        " \n                    "
                                                    )
                                                  ])
                                                : order.service_id !== 1 &&
                                                  !order.service_request
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "multiLangName"
                                                          )(
                                                            _vm.globalState
                                                              .services[
                                                              order.service_id
                                                            ]
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.$options.filters.orderAdditionalHours(
                                                order
                                              )
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                     " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "orderAdditionalHours"
                                                          )(order)
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ])
                                                : _vm._e()
                                            ])
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "text-right text-remark" },
                                      [
                                        order.subscription_id
                                          ? _c(
                                              "span",
                                              { staticClass: "text-orange" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fal fa-calendar-alt"
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.subscription.title"
                                                      )
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        order.package_id
                                          ? _c(
                                              "span",
                                              { staticClass: "text-orange" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fal fa-layer-group"
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("multiLangName")(
                                                        order.package
                                                          .package_type
                                                      )
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        order.host_id
                                          ? _c(
                                              "span",
                                              { staticClass: "text-orange" },
                                              [
                                                _c("i", {
                                                  staticClass: "fal fa-bed"
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.my_reservations.for_host"
                                                      )
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !order.package_id &&
                                        order.is_no_datetime_booking &&
                                        order.status < 1
                                          ? _c(
                                              "span",
                                              { staticClass: "text-orange" },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.booking.new_booking.booking_type_flexible"
                                                      )
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    order.service_request
                                      ? _c(
                                          "div",
                                          { staticClass: "pt-3 text-small" },
                                          [
                                            order.service_request
                                              .building_address
                                              ? _c("div", [
                                                  _c("i", {
                                                    staticClass:
                                                      "fal fa-map-marker-alt"
                                                  }),
                                                  _vm._v(
                                                    "  " +
                                                      _vm._s(
                                                        order.service_request
                                                          .building_address
                                                      ) +
                                                      "\n                "
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            order.service_request
                                              .payment_status === 0
                                              ? _c(
                                                  "div",
                                                  { staticClass: "pt-2" },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fal fa-file-alt -status-new"
                                                    }),
                                                    _vm._v(
                                                      "  " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.service_request.service_request_document"
                                                          )
                                                        ) +
                                                        "\n                "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("hr"),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-order-notification"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "bullet-notification-yellow"
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fas fa-circle -status-pending"
                                                    })
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm._f("multiLangName")(
                                                        order.service_request
                                                          .service_request_status
                                                      )
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    order.paid_status === 1 &&
                                    order.cleaning_date &&
                                    !order.confirm_cleaning_date &&
                                    !order.declined_order_data
                                      ? _c("div", { staticClass: "mt-3" }, [
                                          _c("hr"),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-order-notification"
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "bullet-notification"
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-circle -status-pending"
                                                  })
                                                ]
                                              ),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.my_reservations.no_confirm_cleaning_datetime"
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    order.declined_order_data &&
                                    order.status === 0 &&
                                    order.selected_professional_id > 0
                                      ? _c("div", { staticClass: "mt-3" }, [
                                          _c("hr"),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-order-notification"
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "bullet-notification"
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-circle -status-alert"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "-status-alert"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.declined_booking.cleaner_declined_booking"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "-status-alert mt-1"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    - " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "declinedReason"
                                                        )(
                                                          order.declined_order_data
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    order.pre_booking_professionals &&
                                    order.status === 0
                                      ? _c("div", [
                                          _c("hr"),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-start align-content-center text-order-notification flex-row flex-wrap"
                                            },
                                            [
                                              _c("div", [
                                                _c("img", {
                                                  attrs: {
                                                    src:
                                                      "/static/img/switch_professional.svg"
                                                  }
                                                })
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "px-2" },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.booking.switch_professional.offer_pre_booking_professionals"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                _vm._l(
                                                  order.pre_booking_professionals,
                                                  function(
                                                    professional,
                                                    index
                                                  ) {
                                                    return _c("span", [
                                                      _c("img", {
                                                        staticClass:
                                                          "rounded-circle",
                                                        class: [
                                                          index === 0
                                                            ? "img-pre-booking-professional-first"
                                                            : "img-pre-booking-professional-other"
                                                        ],
                                                        attrs: {
                                                          src:
                                                            professional.full_picture,
                                                          width: "24"
                                                        }
                                                      })
                                                    ])
                                                  }
                                                ),
                                                0
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    order.status === 1 &&
                                    _vm.$options.filters.professionalJobStatus(
                                      order,
                                      false
                                    )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-order-notification"
                                          },
                                          [
                                            _c("hr"),
                                            _vm._v(" "),
                                            _c("div", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$options.filters.professionalJobStatus(
                                                    order,
                                                    false
                                                  )
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    order.status === 2 && !order.cancel
                                      ? _c(
                                          "div",
                                          { staticClass: "text-small" },
                                          [
                                            _c("hr"),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "-status-alert" },
                                              [_vm._v("หมายเหตุ")]
                                            ),
                                            _vm._v(
                                              " คุณสามารถให้ทิปแก่ผู้ให้บริการได้ โดยเข้าไปดูรายละเอียด\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-outline-info btn-block mt-3",
                                        on: {
                                          click: function($event) {
                                            return _vm.viewOrderDetail(order)
                                          }
                                        }
                                      },
                                      [_vm._v("ดูรายละเอียด")]
                                    ),
                                    _vm._v(" "),
                                    order.status === 2 && !order.cancel
                                      ? _c("section", [
                                          !order.is_received_order &&
                                          !order.order_report_issue
                                            ? _c("div", [
                                                _c("hr"),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "mb-3 text-left text-small"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "-status-alert"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.received_order.please_read"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.received_order.section_title"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-block btn-info",
                                                    on: {
                                                      click: function($event) {
                                                        $event.preventDefault()
                                                        return _vm.openReceivedOrderModal(
                                                          index,
                                                          order.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.button.received_order"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          (order.is_received_order ||
                                            order.order_report_issue) &&
                                          !order.is_reviewed &&
                                          order.review_days > 0
                                            ? _c("div", [
                                                _c("hr"),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticClass: "text-small",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.$options.filters.reviewDurationText(
                                                        order
                                                      )
                                                    )
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-info btn-block mt-3",
                                                    on: {
                                                      click: function($event) {
                                                        $event.preventDefault()
                                                        return _vm.openReviewModal(
                                                          index,
                                                          order.id,
                                                          order.professional
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.my_reservations.give_a_review"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          order.is_received_order &&
                                          order.is_reviewed
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "-status-accepted mt-3"
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa fa-check-circle"
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.my_reservations.reviewed"
                                                        )
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    order.order_payment_failure
                                      ? _c(
                                          "div",
                                          { staticClass: "text-remark" },
                                          [
                                            _c("hr"),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "pb-2" }, [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-exclamation-triangle text-orange"
                                              }),
                                              _vm._v(
                                                "\n                  เราไม่สามารถเรียกเก็บเงินจากบัตรของคุณได้เนื่องจาก\n                  " +
                                                  _vm._s(
                                                    order.order_payment_failure
                                                      .failure_message
                                                  ) +
                                                  "\n                  คุณสามารถเปลี่ยนชำระเงินด้วยวิธีโอนเงินแทนได้\n                "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "text-secondary",
                                                attrs: { href: "" },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.changePaymentMethod(
                                                      order
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "card border-secondary"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "card-body p-3"
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fal fa-money-bill-wave"
                                                        }),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.payment_method.bank_transfer"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ])
                          : _c("div", { staticClass: "p-4 text-center" }, [
                              _c("label", [_vm._v("ยังไม่มีข้อมูล")])
                            ])
                      })
                    : _vm._e()
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("review-modal", {
            ref: "reviewModal",
            on: {
              onReviewedOrder: function($event) {
                return _vm.updateOrder("reviewedOrder")
              }
            }
          }),
          _vm._v(" "),
          _c("received-order-modal", {
            ref: "receivedOrderModal",
            on: {
              onReceivedOrder: function($event) {
                return _vm.updateOrder("receivedOrder")
              }
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36205bcb", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36205bcb","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatBooking/components/Carousel.vue
// module id = 2094
// module chunks = 0